export default {
  effects: {
    captions: {
      blur: 'Sfoca',
      crop: 'Ritaglia',
      enhance: 'Accentua',
      flip: 'Capovolgi',
      grayscale: 'Bianconero',
      invert: 'Inverti',
      mirror: 'Specchia',
      rotate: 'Ruota',
      sharp: 'Nitidezza',
    },
    apply: 'Applica',
  },
}
